import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";

const messages = {
	...englishMessages,
	...spanishMessages,
};

export { messages };
